// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"b7926994","165":"b23a3e33","256":"381b9e6e","313":"0a83469d","421":"dfcb881f","619":"e974d060","672":"d82765f8","682":"659d57c3","697":"1a3cf8fe","977":"6db22e6e"}[chunkId] + ".chunk.css";
};